import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { StylesProvider, text, border, padding } from '@rexlabs/styling';
import CoreButton from '../core';
var tokens = {
  button: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, text.tokens({
    target: 'button.link',
    color: function color(_ref) {
      var token = _ref.token;
      return token('color.textStyle.link.idle.default');
    },
    textDecoration: function textDecoration() {
      return 'underline';
    }
  })), border.tokens({
    target: 'button.link',
    all: {
      color: function color() {
        return 'transparent';
      }
    }
  })), padding.tokens({
    target: 'button.link',
    all: 'none'
  })), {}, {
    height: function height(_ref2) {
      var token = _ref2.token;
      return token('button.link.height', '2rem');
    },
    background: {
      color: function color(_ref3) {
        var token = _ref3.token;
        return token('button.link.background.color', token('color.container.static.default'));
      }
    },
    hover: _objectSpread(_objectSpread(_objectSpread({}, text.tokens({
      target: 'button.link.hover'
    })), border.tokens({
      target: 'button.link.hover',
      all: {
        color: function color() {
          return 'transparent';
        }
      }
    })), {}, {
      background: {
        color: function color(_ref4) {
          var token = _ref4.token;
          return token('button.link.hover.background.color', token('color.container.static.default'));
        }
      },
      textDecorationColor: function textDecorationColor(_ref5) {
        var token = _ref5.token;
        return token('color.border.secondary.hover.default');
      }
    }),
    active: _objectSpread(_objectSpread(_objectSpread({}, text.tokens({
      target: 'button.link.active'
    })), border.tokens({
      target: 'button.link.active',
      all: {
        color: 'link.active.default'
      }
    })), {}, {
      background: {
        color: function color(_ref6) {
          var token = _ref6.token;
          return token('button.link.active.background.color', token('color.container.static.default'));
        }
      },
      textDecorationColor: function textDecorationColor(_ref7) {
        var token = _ref7.token;
        return token('color.border.secondary.active.default');
      }
    })
  })
};
export var LinkButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(CoreButton, _extends({}, props, {
    ref: ref
  })));
});
export default LinkButton;